import { Status } from "models/account-status.model";
import { ResponseBroker } from "models/response-broker.model";
import { PortimaConnectUserInfo } from "models/user-info.model";
import { useEffect, useState } from "react";
import OnboardingApi from "services/OnboardingApi";
import portima from "utils/goblins";
import AuthenticationService from "services/AuthenticationService";

import config from '../config';

export enum OnboardingErrorType {
    UNKNOWN,
    PORTIMACONNECT_MISSING,
    ARTIFACT_MISSING,
}

interface OnboardingProps {
    phoneNumber?: string;
    status?: Status;
    errorOccur: (errorType: OnboardingErrorType) => void;
}

const useOnboarding = ({
    phoneNumber,
    status,
    errorOccur,
}: OnboardingProps): [PortimaConnectUserInfo, boolean, () => void] => {
    const [userInfo, setUserInfo] = useState<PortimaConnectUserInfo>({
        name: "",
        phoneNumber: phoneNumber !== undefined ? phoneNumber : "",
        status: status !== undefined ? status : "notfound",
    });
    const [inProgress, setInProgress] = useState(true);

    const onboardingApi: OnboardingApi = new OnboardingApi();

    async function detectPortimaConnect() {
        console.log({ config });
        const portimaSso = new portima.wsk.ws.sso.CConnSess();
        try {
            const vCRes = await portimaSso.fTokenGet(config.SP, "", "", config.PI2_JWT_V1);

            if (vCRes && vCRes.artifact) {
                new AuthenticationService().setAuthToken(vCRes.artifact);
                const response: ResponseBroker = await checkIfItsmeAccountIsLinked();
                if (response !== null) {
                    setUserInfo({
                        ...userInfo,
                        name: response.name,
                        status: response.status === "Link" ? "link" : "notlink",
                    });
                    setInProgress(false);
                } else {
                    handleError(OnboardingErrorType.UNKNOWN);
                }
            } else {
                console.error("Can't get artifact");
                handleError(OnboardingErrorType.ARTIFACT_MISSING);
            }
        } catch (error) {
            console.error({ error });
            handleError(OnboardingErrorType.PORTIMACONNECT_MISSING);
        } finally {
            setInProgress(false);
        }
    }

    useEffect(() => {
        detectPortimaConnect();
    }, []);

    const handleError = (type: OnboardingErrorType) => {
        setUserInfo({
            ...userInfo,
            status: "notfound",
        });
        errorOccur(type);
    };

    const checkIfItsmeAccountIsLinked = (): Promise<ResponseBroker> => {
        return onboardingApi.checkIfAccountIsLinked()?.then(
            (response: ResponseBroker) => {
                return response;
            },
            (error) => {
                throw error;
            },
        );
    };

    const unlinkAcount = (): void => {
        onboardingApi.unlinkAccount().then((response) => {
            setUserInfo({
                ...userInfo,
                status: response ? "unlink" : "link",
            });
        });
    };

    return [userInfo, inProgress, unlinkAcount];
};

export default useOnboarding;
